<template>
  <div class="index-box">
    <div class="index">
      <h3>注文書</h3>
      <ul>
        <li>
          <router-link :to="{ name: 'proceedOrder', query: { state: 1 } }">
            <img src="../../../assets/img/user_home/1-1.png" alt />
            <p>
              未提出(
              <span>{{ orderTabData.orderTemporary }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'proceedOrder', query: { state: 0 } }">
            <img src="../../../assets/img/user_home/1-2.png" alt />
            <p>
              代行注文書(
              <span>{{ orderTabData.orderAll }}</span> )
            </p>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/user/index">
            <img src="../../../assets/user/raku.png" alt />
            <p>
              ラク注文書(
              <span>{{ getOrderData.orderConfirm }}</span> )
            </p>
          </router-link>
        </li> -->
        <!-- <li>
          <router-link to="/user/issueProduct">
            <img src="../../../assets/user/rightmain2.png" alt />
            <p>
              問題商品(
              <span>{{ getOrderData.orderPay }}</span> )
            </p>
          </router-link>
        </li> -->
        <li>
          <router-link :to="{ name: 'proceedOrder', query: { state: 2 } }" style="margin-right: 0">
            <img src="../../../assets/img/user_home/1-3.png" alt />
            <p>
              見積中(
              <span>{{ orderTabData.orderConfirm }}</span> )
            </p>
          </router-link>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="index">
      <h3>中国国内物流状態</h3>
      <ul>
        <li>
          <router-link to="/user/domesticLogistics?state=1">
            <img src="../../../assets/img/user_home/2-1.png" alt />
            <p>
              配送待ち(
              <span>{{ logisticTabData.num1Total }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/domesticLogistics?state=2">
            <img src="../../../assets/img/user_home/2-2.png" alt />
            <p>
              配送中(
              <span>{{ logisticTabData.num2Total }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/domesticLogistics?state=3">
            <img src="../../../assets/img/user_home/2-3.png" alt />
            <p>
              到着作業待ち( <span>{{ logisticTabData.num3Total }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/domesticLogistics?state=4">
            <img src="../../../assets/img/user_home/2-4.png" alt />
            <p>
              オプション作業中(
              <span>{{ logisticTabData.num4Total }}</span> )
            </p>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="index">
      <h3>配送依頼</h3>
      <ul>
        <li>
          <router-link to="/user/warehouse">
            <img src="../../../assets/img/user_home/3-1.png" alt />
            <p>倉庫</p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/deliverOrder?state=2">
            <img src="../../../assets/img/user_home/3-2.png" alt />
            <p>
              配送見積中 (
              <span>{{ pOrdnoTabData.orderConfirm }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/deliverOrder?state=3">
            <img src="../../../assets/img/user_home/3-3.png" alt />
            <p>
              送料支払い待ち (
              <span>{{ pOrdnoTabData.orderPay }}</span> )
            </p>
          </router-link>
        </li>
        <li>
          <router-link to="/user/deliverOrder?state=4">
            <img src="../../../assets/img/user_home/3-4.png" alt />
            <p>
              国際発送済み (
              <span>{{ pOrdnoTabData.orderDelivery }}</span> )
            </p>
          </router-link>
        </li>
      </ul>
      <!-- {{ getOrderData }} -->
    </div>
  </div>
</template>
<script>
import { tabDataCount } from "../../../api/API/user";

export default {
  data() {
    return {
      logisticTabData: {},
      orderTabData: {},
      pOrdnoTabData: {},
    };
  },
  created() {
    this.tabDataCount();
  },
  methods: {
    // 获取个人中心首页各项统计
    tabDataCount() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "tabDataCount",
        token: localStorage.getItem("token"),
      };
      tabDataCount(list).then((res) => {
        this.logisticTabData = res.data.logisticTabData;
        this.orderTabData = res.data.orderTabData;
        this.pOrdnoTabData = res.data.pOrdnoTabData;
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.index-box {
  padding: 40px;
}

.index {
  height: 240px;

  margin-bottom: 30px;
  border-bottom: 1px solid #e9e9e9;

  &:nth-last-child(1) {
    border: 0;
    margin-bottom: 0;
  }

  h3 {
    margin-bottom: 30px;
    color: #222;
    font-size: 20px;
    font-weight: 500;
  }

  ul {
    padding-bottom: 20px;
    display: flex;

    li {
      flex: 1;

      text-align: center;

      a {
        padding: 20px 0;
        display: block;

        // width: 50px;
        // height: 100px;
        // margin: 50px 190px 0 0;
        &:hover {
          background-color: #f9f9f9;
          border-radius: 20px;
        }

        font-size: 20px;

        img {
          width: 50px;
          height: 50px;
        }

        p {
          margin-top: 30px;
          color: #333;

          span {
            color: #b7040b !important;
          }
        }
      }
    }
  }
}</style>